<script>
  export default {};
</script>

<template>
  <transition name="modal">
    <div class="modal">
      <div class="modal__mask" @click="$emit('close')"></div>
      <div class="modal__dialog">
        <button class="modal__close close" @click="$emit('close')">×</button>
        <div class="modal__header">
          <slot name="header"></slot>
        </div>

        <div class="modal__body">
          <slot name="body"></slot>
        </div>

        <div class="modal__footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// Modal.vue?1ea52e32